import type EmailadsOptInState from "./schema/EmailadsOptInState";
import { createStore } from "owa-satcheljs";

const emailadsOptInState: EmailadsOptInState = {
    emailAdsOptInBit: -1,
};

const defaultExport: () => EmailadsOptInState = createStore<EmailadsOptInState>("emailadsOptInState", emailadsOptInState);
export default defaultExport;
